import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";

type HcbbBackButtonProps = {
  /** Explicit destination; falls back to a history step when omitted. */
  to?: string;
  /**
   * Accessible name. "Back" alone is ambiguous once a screen can be
   * reached from more than one place; the visible text is unchanged.
   */
  label?: string;
};

export const HcbbBackButton = ({ to, label }: HcbbBackButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      type="button"
      variant="link"
      aria-label={label}
      onClick={() => (to ? navigate(to) : navigate(-1))}
      className="hover:no-underline"
    >
      <ChevronLeft aria-hidden="true" /> Back
    </Button>
  );
};
